import './football.css';

const Football = () => {
    return (
        <a href='/football'>
            <div className="column football">
                <h2 className="title">FOOTBALL</h2>
            </div>
        </a>
    );
}

export default Football;